import { render, staticRenderFns } from "./Form-product.vue?vue&type=template&id=0cab61d1&scoped=true&"
import script from "./Form-product.vue?vue&type=script&lang=js&"
export * from "./Form-product.vue?vue&type=script&lang=js&"
import style0 from "./Form-product.vue?vue&type=style&index=0&id=0cab61d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cab61d1",
  null
  
)

export default component.exports